import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { SelectElement } from "../../../components/selectElement2";

const initialForm = {
    ideUbicacion: '',
    tipoAtencion: '',
    complemento: '',
    identificador: '',
    sigla: '',
    orden: '',
    prioritario: '',
    cantidad: '',
    color: '#000000',
    chkPrioritario: false,
    chkPermiteTraslado: false,
    icono: ''
}

export const CrearTipoAtencionModal = ({ show, onClose, onSave, iconos, ubicaciones, initialData = null,
    modo = "crear" }) => {

    // const [ubicaciones, setUbicaciones] = useState([]);
    const [form, setForm] = useState(initialForm);

    const resetForm = () => {
        setForm(initialForm);
    };

    // useEffect( () => {

    //     const codigoEntidad = localStorage.getItem("codigoEntidad");

    //     if (!codigoEntidad) return;

    //     const fetch = async () => {
    //         try {

    //             const resp = await serverApi.post(`/ubicaciones/select-ubicaciones`, { codigoEntidad } );
    //             console.log(resp);

    //             const opciones = resp.data.data.map( (item) => ( { value: item.ideUbicacion, label: item.nombreUbicacion.toUpperCase(), data:item.codigoUbicacion } ) )
    //             setUbicaciones( opciones )

    //         } catch (error) {
    //             console.error("Error al obtener clases Modulos", error);
    //         } finally {

    //         }
    //     };

    //     fetch();

    // },[])

    useEffect(() => {

        if (!show) return;

        if (initialData) {

            setForm({
                ...initialData,
                identificador: initialData.codigoTipoAtencion || '',
                chkPrioritario: initialData.indPrioridad === 1,
                chkPermiteTraslado: initialData.permiteTraslado === 1
            });

        } else {

            resetForm();

        }

    }, [show, initialData]);



    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = () => {

        if (!form.tipoAtencion.trim()) return;
        if (!form.identificador.trim()) return;

        onSave({
            ...form,
            tipoAtencion: form.tipoAtencion.toUpperCase(),
            identificador: form.identificador.toUpperCase(),
            sigla: form.sigla.toUpperCase()
        });
    };

    const handleSelectUbicacion = (selected) => {
        setForm(prev => ({
            ...prev,
            idUbicacion: selected.value,
            codigoUbicacion: selected.data
        }));
    };

    const onChangeIconoEdita = (selected) => {
        setForm(prev => ({
            ...prev,
            icono: selected.value,

        }));
    };



    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size="lg"
            contentClassName="rounded-4 shadow-lg border-0"
        >
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold fs-4">
                    {modo === 'crear'
                        ? 'Crear Tipo de Atención'
                        : 'Editar Tipo de Atención'
                    }
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form className="row g-3">

                    {/* <Form.Group>
                        <Form.Label>Sede/ubicación</Form.Label>
                        <SelectElement
                            options= { ubicaciones }
                            name={ `codigoUbicacion`}
                            isMulti= {false}
                            closeOnMenuSelect= {true}
                            value={ubicaciones.find(u => u.value === form.ideUbicacion)}
                            onChange= {(selected) => handleSelectUbicacion(selected)}
                            // onChange= {(selected) => setForm(prev => ({ ...prev, ubicacion: selected }))}

                            
                            classname= "form-control form-control-lg" 
                            isClearable = {false}
                        />
    
                    </Form.Group> */}

                    {modo === 'crear' ? (

                        <Form.Group>
                            <Form.Label>Sede/Ubicación</Form.Label>

                            <SelectElement
                                options={ubicaciones}
                                value={ubicaciones.find(
                                    u => u.value === form.ideUbicacion
                                )}
                                onChange={handleSelectUbicacion}
                                isMulti={false}
                                isClearable={false}
                            />
                        </Form.Group>

                    ) : (

                        <Form.Group>
                            <Form.Label>Sede</Form.Label>

                            <Form.Control
                                value={form.nombreUbicacion || ''}
                                disabled
                            />
                        </Form.Group>

                    )}

                    <Form.Group className="col-md-6">
                        <Form.Label>Tipo Atención</Form.Label>
                        <Form.Control
                            name="tipoAtencion"
                            value={form.tipoAtencion}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-6">
                        <Form.Label>Complemento</Form.Label>
                        <Form.Control
                            name="complemento"
                            value={form.complemento}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-4">
                        <Form.Label>Identificador</Form.Label>
                        <Form.Control
                            name="identificador"
                            maxLength={2}
                            value={form.identificador}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-4">
                        <Form.Label>Sigla</Form.Label>
                        <Form.Control
                            name="sigla"
                            value={form.sigla}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-4">
                        <Form.Label>Orden</Form.Label>
                        <Form.Control
                            type="number"
                            name="orden"
                            value={form.orden}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-4">
                        <Form.Label>Atn. Prioritaria</Form.Label>
                        <Form.Control
                            type="number"
                            name="prioritario"
                            value={form.prioritario}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-4">
                        <Form.Label>Atn. Corriente</Form.Label>
                        <Form.Control
                            type="number"
                            name="cantidad"
                            value={form.cantidad}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-4">
                        <Form.Label>Icono</Form.Label>
                        <SelectElement
                            options={iconos}
                            isMulti={false}
                            closeOnMenuSelect={true}
                            value={iconos.find(u => u.value === form.icono)}
                            onChange={(selected) => onChangeIconoEdita(selected)}
                            classname=""
                            isClearable={false}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-4">
                        <Form.Label>Color</Form.Label>
                        <Form.Control
                            type="color"
                            name="color"
                            value={form.color}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-4 d-flex align-items-end">
                        <Form.Check
                            type="switch"
                            label="Prioritario"
                            name="chkPrioritario"
                            checked={form.chkPrioritario}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="col-md-4 d-flex align-items-end">
                        <Form.Check
                            type="switch"
                            label="Permite traslados"
                            name="chkPermiteTraslado"
                            checked={form.chkPermiteTraslado}
                            onChange={handleChange}
                        />
                    </Form.Group>



                </Form>
            </Modal.Body>

            <Modal.Footer className="border-0">
                <Button variant="light" onClick={onClose}>
                    Cancelar
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSubmit}
                >
                    {modo === 'crear'
                        ? 'Guardar'
                        : 'Actualizar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};